import { useCallback, useEffect, useState } from "react";
import { Button } from "@lannister/duplo";

import { PaymentMethodType } from '../../common/constants';
import ApplePayButton from "../../Components/partials/apple-pay-btn/applePayButton";
import { PaymentMethodOptions } from "../common/paymentMethodOptions";
import styles from "../Checkout/styles";
import PoweredBy from "../common/poweredBy";

const PaymentPanel = ({
    isCardEnabled,
    isWalletEnabled,
    isApplePayEnabled,
    isSahlPayEnabled,
    handleChange,
    onSubmit,
    isLoading,
    onChangeSelectedPaymentMethod,
    isFormValid,
    amount,
    currency,
    shouldShowAmount,
    isSaveCardOptionEnabled }) => {

    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null)

    const onChangePaymentMethod = useCallback((value) => {
        const selectedMethod = Number(value);
        setSelectedPaymentMethod(selectedMethod)
        onChangeSelectedPaymentMethod(selectedMethod)
    }, [setSelectedPaymentMethod, onChangeSelectedPaymentMethod])

    useEffect(() => {
        const selectedMethod = isApplePayEnabled ? PaymentMethodType.ApplePay : PaymentMethodType.BankCard
        setSelectedPaymentMethod(selectedMethod)
        onChangePaymentMethod(selectedMethod)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div> 
            <div style={styles.card}>
                <PaymentMethodOptions
                    isCardEnabled={isCardEnabled}
                    isWalletEnabled={isWalletEnabled}
                    isApplePayEnabled={isApplePayEnabled}
                    isSahlPayEnabled={isSahlPayEnabled}
                    isSaveCardOptionEnabled={isSaveCardOptionEnabled}
                    handleChange={handleChange}
                    onChangePaymentMethod={onChangePaymentMethod}
                />
            </div>

            <div style={{ display: "grid", padding: "12px 0" }}>
                {
                    selectedPaymentMethod === PaymentMethodType.ApplePay ?
                        <ApplePayButton onClick={onSubmit} disabled={!isFormValid || isLoading} /> :
                        <Button onClick={onSubmit} isLoading={isLoading} disabled={!isFormValid}>
                            Pay{shouldShowAmount ? ` ${amount} ${currency}` : ''}
                        </Button>
                }


            </div>

           <PoweredBy />
        </div>
    );
}

export default PaymentPanel;
